var map = {
	"./LTC.svg": 773,
	"./V-round.svg": 774,
	"./account-check.svg": 775,
	"./achievement.svg": 776,
	"./add.svg": 619,
	"./aim.svg": 777,
	"./alarm.svg": 778,
	"./allow.svg": 242,
	"./angle-double-left.svg": 361,
	"./angle-left.svg": 148,
	"./angle-right.svg": 212,
	"./anticheat-circle.svg": 779,
	"./antichit-warning.svg": 780,
	"./arrow-down.svg": 243,
	"./arrow-left.svg": 244,
	"./arrow-right.svg": 214,
	"./arrow-up-right.svg": 781,
	"./arrow-up.svg": 782,
	"./attention.svg": 362,
	"./auth_discord.svg": 783,
	"./auth_facebook.svg": 784,
	"./auth_google.svg": 785,
	"./auth_steam.svg": 786,
	"./auth_vk.svg": 787,
	"./berserk.svg": 788,
	"./bitcoin.svg": 620,
	"./blog.svg": 789,
	"./bona.svg": 790,
	"./bonusWarning.svg": 791,
	"./bookmark.svg": 792,
	"./bulb.svg": 621,
	"./calendar.svg": 295,
	"./call.svg": 363,
	"./cam-circle.svg": 622,
	"./cam.svg": 793,
	"./cells.svg": 794,
	"./chart-down.svg": 364,
	"./chart.svg": 623,
	"./chat.svg": 172,
	"./chatvvv.svg": 599,
	"./checkmark-blue.svg": 795,
	"./checkmark-double-green.svg": 624,
	"./checkmark-green-plain.svg": 596,
	"./checkmark-green.svg": 285,
	"./checkmark-red.svg": 796,
	"./checkmark-white.svg": 603,
	"./checkmark.svg": 365,
	"./close-red.svg": 625,
	"./close.svg": 133,
	"./coins-gold.svg": 245,
	"./coins-in-round.svg": 366,
	"./coins-new.svg": 626,
	"./coins-payout.svg": 797,
	"./coins-yellow.svg": 798,
	"./coins.svg": 210,
	"./colorpicker.svg": 799,
	"./combined.svg": 800,
	"./copy.svg": 597,
	"./cost.svg": 211,
	"./create.svg": 801,
	"./credit-card-sponsor.svg": 802,
	"./credit-card.svg": 803,
	"./crown.svg": 804,
	"./dashboard.svg": 805,
	"./denied.svg": 215,
	"./devices/android.svg": 367,
	"./devices/ios.svg": 368,
	"./devices/mac.svg": 369,
	"./devices/windows.svg": 370,
	"./diamond.svg": 371,
	"./discord.svg": 806,
	"./dislike.svg": 807,
	"./done-circle.svg": 808,
	"./dots.svg": 372,
	"./double-check.svg": 373,
	"./download.svg": 627,
	"./duration.svg": 809,
	"./earn.svg": 628,
	"./edit.svg": 600,
	"./email.svg": 810,
	"./enter.svg": 811,
	"./error-circle.svg": 629,
	"./error.svg": 374,
	"./euro.svg": 286,
	"./exit.svg": 601,
	"./eye-closed.svg": 812,
	"./eye.svg": 813,
	"./facebook.svg": 814,
	"./filter-arrow.svg": 150,
	"./filter.svg": 815,
	"./fixed.svg": 630,
	"./flag.svg": 816,
	"./gamepad.svg": 631,
	"./gamepad2.svg": 817,
	"./gear.svg": 632,
	"./gem.svg": 818,
	"./gift.svg": 819,
	"./giftAuth.svg": 820,
	"./globe.svg": 633,
	"./google.svg": 634,
	"./group.svg": 635,
	"./halfstar.svg": 375,
	"./heart.svg": 279,
	"./hide.svg": 604,
	"./home.svg": 821,
	"./info.svg": 104,
	"./instagram.svg": 822,
	"./keyboard.svg": 605,
	"./kill.svg": 376,
	"./leaderboard.svg": 377,
	"./level.svg": 823,
	"./like.svg": 378,
	"./link-extra.svg": 379,
	"./link.svg": 173,
	"./list.svg": 824,
	"./location.svg": 825,
	"./lock-open.svg": 296,
	"./lock.svg": 287,
	"./mail-support.svg": 380,
	"./mail.svg": 636,
	"./marketplace-delete.svg": 297,
	"./max-loses.svg": 826,
	"./medal.svg": 637,
	"./menu.svg": 827,
	"./min-players.svg": 638,
	"./minus.svg": 828,
	"./money.svg": 829,
	"./money_2_sponsor.svg": 830,
	"./money_sponsor.svg": 831,
	"./my-account.svg": 832,
	"./new-rating.svg": 594,
	"./nominations.svg": 639,
	"./not-fixed.svg": 640,
	"./notifications.svg": 833,
	"./offerwall.svg": 834,
	"./other.svg": 835,
	"./overwolf.svg": 641,
	"./participants.svg": 642,
	"./paypal.svg": 836,
	"./pending.svg": 643,
	"./phone.svg": 837,
	"./player-empty.svg": 246,
	"./players.svg": 381,
	"./plus.svg": 213,
	"./prize.svg": 838,
	"./protect.svg": 839,
	"./qiwi.svg": 840,
	"./question-mark-white.svg": 247,
	"./question-mark-yellow.svg": 593,
	"./rating.svg": 841,
	"./readed-mail.svg": 382,
	"./referral.svg": 298,
	"./refresh.svg": 383,
	"./reglament.svg": 842,
	"./round-currencies/coins.svg": 644,
	"./round-currencies/money.svg": 645,
	"./round-currencies/tickets.svg": 646,
	"./ru-card.svg": 843,
	"./sad.svg": 282,
	"./sale.svg": 647,
	"./santa-hat.svg": 384,
	"./sbp.svg": 844,
	"./search.svg": 845,
	"./security.svg": 846,
	"./send.svg": 847,
	"./settings.svg": 848,
	"./share.svg": 849,
	"./shield-user.svg": 850,
	"./shield.svg": 144,
	"./shop.svg": 385,
	"./shop_icon.svg": 851,
	"./sidebar.svg": 852,
	"./sign-in.svg": 360,
	"./smile-big.svg": 853,
	"./smile.svg": 854,
	"./star-gold.svg": 209,
	"./star-grey.svg": 283,
	"./star-round.svg": 855,
	"./star-small.svg": 856,
	"./star-v.svg": 857,
	"./star-violet.svg": 858,
	"./star-with-paddings.svg": 648,
	"./star.svg": 134,
	"./status.svg": 105,
	"./store.svg": 386,
	"./success.svg": 387,
	"./target.svg": 649,
	"./telegram-blue.svg": 606,
	"./telegram.svg": 174,
	"./tetris.svg": 859,
	"./thunder.svg": 388,
	"./ticket-big.svg": 860,
	"./ticket.svg": 861,
	"./tiktok.svg": 862,
	"./time-schedule.svg": 863,
	"./time.svg": 650,
	"./timer.svg": 864,
	"./top_sponsor.svg": 865,
	"./trash.svg": 607,
	"./triangle.svg": 595,
	"./trophy.svg": 598,
	"./twitch.svg": 288,
	"./twitter.svg": 866,
	"./twitter2.svg": 867,
	"./usd-card.svg": 868,
	"./user.svg": 248,
	"./v.svg": 281,
	"./verified.svg": 608,
	"./vk.svg": 869,
	"./wait.svg": 609,
	"./waiting.svg": 870,
	"./wallet-header.svg": 651,
	"./wallet.svg": 871,
	"./warning-2-red.svg": 652,
	"./warning-2.svg": 872,
	"./warning.svg": 154,
	"./webmoney.svg": 873,
	"./world.svg": 653,
	"./x2.svg": 654,
	"./youtube-white.svg": 874,
	"./youtube.svg": 289
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;